module.exports = __webpack_public_path__ + "static/media/Kinjal Gada.d782e75b.png";